import React, {Component} from 'react';
import styled from 'styled-components';
import H from "../typography/H";
import FilterItem from "./FilterItem";
import RangeSlider from "../common/RangeSlider";
import {bindActionCreators} from "redux";
import * as Actions from "../../actions/actions";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import Toggle from "../common/Toggle";
import Button from "../common/Button";

const FilterCard = styled.div`
  padding: 40px;
  background-color: ${p => p.theme.cFrameBg};
  max-width: 460px;
  margin: auto;
`;

const Description = styled.div`
  margin-bottom: 50px;
  text-align: center;
`;

const Title = styled.div`
  margin-bottom: 15px;
  color: ${p => p.theme.cTheme};
`;

const Text = styled.div`
  
`;

class FilterSection extends Component {
    render() {

        const width = this.props.sliderParameters.width[this.props.type];
        const height = this.props.sliderParameters.height[this.props.type];
        const step = this.props.sliderParameters.step[this.props.type];

        return (
            <section className={this.props.className}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <Description>
                                <Title>
                                    <H size={2} styleSize={3}>Или выберите свой размер</H>
                                </Title>
                                <Text>
                                    <p>
                                        Помимо стандартных окон и дверей для типовых построек у нас имеется богатый
                                        ассортимент продукции нестандартных размеров
                                    </p>
                                </Text>
                            </Description>
                        </div>
                    </div>
                    <FilterCard>
                        <FilterItem label={'Шаг 1.'} item={
                            <Toggle flipped={!(this.props.type === 'windows')}
                                    callback={this.props.flipFilterSwitch}/>
                        }/>
                        <FilterItem label={'Шаг 2.'} item={
                            <div>
                                <RangeSlider value={this.props.widthValue} field={{min: width.min, max: width.max, step: step}}
                                             callback={(value) => {
                                                 this.props.setDimensions({
                                                     param: 'width',
                                                     value: value,
                                                 })
                                             }}/>
                                <RangeSlider value={this.props.heightValue} field={{min: height.min, max: height.max, step: step}}
                                             callback={(value) => {
                                                 this.props.setDimensions({
                                                     param: 'height',
                                                     value: value,
                                                 })
                                             }}/>
                            </div>
                        } microcopy={'При отсутствии точного размера продукии мы покажем ближайший по размеру вариант'}/>
                        <FilterItem label={'Шаг 3.'} item={
                            <div>
                                <Button to={'/catalog'} fullWidth label={'Показать подборку'}/>
                            </div>
                        }/>
                    </FilterCard>
                </div>
            </section>
        );
    };
}

function mapStateToProps(state) {
    const type = state.getIn(['filter', 'type']);
    return {
        type: type,
        widthValue: state.getIn(['filter', 'sliderValues', 'width', type]),
        heightValue: state.getIn(['filter', 'sliderValues', 'height', type]),
        sliderParameters: state.getIn(['filter', 'sliderParameters']),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        flipFilterSwitch: Actions.flipFilterSwitch,
        setDimensions: Actions.setDimensions,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(FilterSection)`
  padding-top: 65px;
  padding-bottom: 65px;
  
`));